import { TFunction } from 'i18next';

export interface AutoDeviceGroupTypeOption {
  label: string;
  value: string | null;
}

const AUTO_DEVICE_GROUP_TYPE_TRANSLATION_KEYS: Record<string, string> = {
  ALL_DEVICES: 'device_groups_auto_device_group_type_all_devices',
  ALL_WATER: 'device_groups_auto_device_group_type_all_water',
  ALL_ENERGY: 'device_groups_auto_device_group_type_all_energy',
  ALL_PRESSURE: 'device_groups_auto_device_group_type_all_pressure',
  ALL_BAROMETRIC_PRESSURE: 'device_groups_auto_device_group_type_all_barometric_pressure',
  ALL_LEVELS: 'device_groups_auto_device_group_type_all_levels',
  ALL_SOIL_MOISTURE: 'device_groups_auto_device_group_type_all_soil_moisture',
  ALL_AIR_HUMIDITY: 'device_groups_auto_device_group_type_all_air_humidity',
  ALL_TEMPERATURES: 'device_groups_auto_device_group_type_all_temperatures',
  ALL_PM10: 'device_groups_auto_device_group_type_all_pm10',
  ALL_PM2_5: 'device_groups_auto_device_group_type_all_pm2_5',
};

const getAutoDeviceGroupTypeLabel = (t: TFunction, value: string): string => {
  const translationKey = AUTO_DEVICE_GROUP_TYPE_TRANSLATION_KEYS[value];

  if (!translationKey) {
    return value;
  }

  return t(translationKey, { defaultValue: value });
};

export const getAutoDeviceGroupTypeOptions = (
  t: TFunction,
  autoDeviceGroupTypes: string[]
): AutoDeviceGroupTypeOption[] => [
  {
    label: t('device_groups_auto_device_group_type_none'),
    value: null,
  },
  ...autoDeviceGroupTypes.map(
    (value: string): AutoDeviceGroupTypeOption => ({
      label: getAutoDeviceGroupTypeLabel(t, value),
      value,
    })
  ),
];
